import { useEffect, useState } from "react";
import Cleave from "cleave.js/react";
//--------------------------------------------------------------------------------------------
import { cityStates } from "src/components/common/cityState";
import Modal from "src/components/common/modal";
import { useMyStore } from "src/components/main/mainStore";
import { 
    MyFormData, 
    myAxios, 
    handleFilesInput, 
    isDevMode, 
} from "src/components/common/functions";
//--------------------------------------------------------------------------------------------
export default function Item({
    numItemsPerColumn, 
    path1, 
    postUrl, 
    keyword, 
    closeIt, 
    handleSubmit, 
    item, 
    hashKeyName, 
    dataFrame, 
    history, 

    contacts, 
}){
    //--------------------------------------------------------------------------------------------
    const localDataFrame = dataFrame.filter(elem => elem.editable && elem.noShow !== keyword);
    const [data, setData] = useState(Object.fromEntries(localDataFrame.map(elem => [elem.selectKey || elem.key, item[elem.selectKey] || item[elem.key] || ""])));
    if("city" in data && "state" in data && data.state){
        let index;
        for(let i = 0; i < localDataFrame.length; i++){
            if(localDataFrame[i].key === "city"){
                index = i;
            }
        }
        if(index){
            localDataFrame[index].options = cityStates[data.state].map(value => ({label: value, value: value}))
        }
    }
    if("organizationHashKey" in data){
        if("requestorHashKey" in data){
            let index;
            for(let i = 0; i < localDataFrame.length; i++){
                if([localDataFrame[i].key, localDataFrame[i].selectKey].includes("requestorHashKey")){
                    index = i;
                }
            }
            if(index){
                localDataFrame[index].options = contacts.filter(contact => contact.organizationHashKey === data.organizationHashKey).map(contact => ({label: contact.firstName + " " + contact.lastName, value: contact.contactHashKey}));
            }
        }
        if("requestor2HashKey" in data){
            let index;
            for(let i = 0; i < localDataFrame.length; i++){
                if([localDataFrame[i].key, localDataFrame[i].selectKey].includes("requestor2HashKey")){
                    index = i;
                }
            }
            if(index){
                localDataFrame[index].options = contacts.filter(contact => contact.organizationHashKey === data.organizationHashKey).map(contact => ({label: contact.firstName + " " + contact.lastName, value: contact.contactHashKey}));
            }
        }
        if("requestor3HashKey" in data){
            let index;
            for(let i = 0; i < localDataFrame.length; i++){
                if([localDataFrame[i].key, localDataFrame[i].selectKey].includes("requestor3HashKey")){
                    index = i;
                }
            }
            if(index){
                localDataFrame[index].options = contacts.filter(contact => contact.organizationHashKey === data.organizationHashKey).map(contact => ({label: contact.firstName + " " + contact.lastName, value: contact.contactHashKey}));
            }
        }
    }
    const cols = Math.ceil(localDataFrame.length / numItemsPerColumn);
    const colIndexesArr = Array.from({length: cols}).map((value, index) => [index * numItemsPerColumn, (index + 1) * numItemsPerColumn]);
    useEffect(() => {
        if(isDevMode) console.log("useEffect");
    }, []);
    //--------------------------------------------------------------------------------------------
    return(
        <Modal
            closeIt = {closeIt}
            title = {keyword}
            width = {"90rem"}
            maxWidth = {"100%"} 
            minWidth = {"18rem"}
            handleFormSubmit = {handleSubmit}
            actionKey = {keyword}
        >
            <input className = "nodisplay" readOnly name = "url" value = {postUrl}/>
            <input className = "nodisplay" readOnly name = {hashKeyName} value = {item[hashKeyName] ?? ""}/>
            <div className = "cssSeperateWhenWide pl-3">
                {colIndexesArr.map((indexes, indexesIndex) => 
                <div key = {indexesIndex} className = "flex-grow-1 mr-3">
                    {localDataFrame.slice(...indexes).map((elem, elemIndex) => 
                    !elem.checkDuplicate?
                    <div key = {elemIndex} className = {"d-flex" + (elemIndex === 0?" my-2":" mb-2")}>
                        <label htmlFor = {elem.selectKey || elem.key} className = "font-weight-bold">{elem.title}:</label>
                        {["text", "email"].includes(elem.type)?
                        <input
                            autoComplete = {elem.autoComplete}
                            type = {elem.type}
                            className = "form-control flex-grow-1 ml-3"
                            id = {elem.key}
                            name = {elem.key}
                            value = {data[elem.key] ?? ""}
                            onChange = {event => {
                                setData({
                                    ...data, 
                                    [elem.key]: event.currentTarget.value
                                });
                            }}
                        />
                        :<></>}
                        {elem.type === "number"?
                        <input
                            type = {elem.type}
                            step = {elem.step}
                            min = {elem.min}
                            max = {elem.max}
                            className = "form-control flex-grow-1 ml-3"
                            id = {elem.key}
                            name = {elem.key}
                            value = {data[elem.key] ?? ""}
                            onChange = {event => {
                                setData({
                                    ...data, 
                                    [elem.key]: event.currentTarget.value
                                });
                            }}
                        />
                        :<></>}
                        {elem.type === "date"?
                        <input
                            type = {elem.type}
                            step = {elem.step}
                            min = {elem.min || "1900-01-01"}
                            max = {elem.max || "2999-12-31"}
                            className = "form-control flex-grow-1 ml-3"
                            id = {elem.key}
                            name = {elem.key}
                            value = {data[elem.key] ?? ""}
                            onChange = {event => {
                                setData({
                                    ...data, 
                                    [elem.key]: event.currentTarget.value
                                });
                            }}
                        />
                        :<></>}
                        {elem.type === "file"?
                        <>
                        <div className = "custom-file ml-3">
                            <input
                                type = "file"
                                className = "custom-file-input"
                                multiple = {elem.multiple}
                                id = {elem.key}
                                name = {elem.key + (elem.multiple?"[]":"")}
                                onChange = {handleFilesInput}
                            />
                            <label htmlFor = {elem.selectKey || elem.key} className = "custom-file-label">Choose file(s)</label>
                        </div>
                        </>:<></>}
                        {elem.type === "phone"?
                        <Cleave
                            pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^" 
                            className = "form-control flex-grow-1 ml-3"
                            id = {elem.key}
                            name = {elem.key}
                            value = {data[elem.key] ?? ""}
                            onChange = {event => {
                                setData({
                                    ...data, 
                                    [elem.key]: event.currentTarget.value
                                });
                            }}
                            options = {{ 
                                blocks:[3, 3, 4],
                                delimiter: "-",
                                numericOnly: true,
                            }}
                        />
                        :<></>}
                        {elem.type === "textarea"?
                        <textarea
                            className = "form-control flex-grow-1 ml-3"
                            rows = {4}
                            id = {elem.key}
                            name = {elem.key}
                            value = {data[elem.key] ?? ""}
                            onChange = {event => {
                                setData({
                                    ...data, 
                                    [elem.key]: event.currentTarget.value
                                });
                            }}
                        />
                        :<></>}
                        {elem.type === "select"?
                        <>
                        <select
                            id = {elem.selectKey || elem.key}
                            name = {elem.selectKey || elem.key}
                            className = "form-control flex-grow-1 ml-3"
                            value = {data[elem.selectKey || elem.key] ?? ""}
                            onChange = {event => {
                                setData({
                                    ...data,
                                    [elem.selectKey || elem.key]: event.currentTarget.value
                                });
                            }}
                        >
                            <option label = "Select" value = ""/>
                            {elem.options?.map((option, optionIndex) => <option key = {optionIndex} label = {option.label} value = {option.value}/>)}
                        </select>
                        </>:<></>}
                    </div>
                    :
                    <CheckDuplicate key = {elemIndex}
                        data = {data}
                        setData = {setData}
                        url = {elem.checkDuplicateLink}
                        itemTitle = {elem.title}
                        itemKey = {elem.key}
                        itemValue = {item[elem.key] ?? ""}
                        hashKey = {item[hashKeyName]}
                        hashKeyName = {hashKeyName}
                        inputType = {elem.type}
                        history = {history}
                        title = {path1}
                    />
                    )}
                </div>)}
            </div>
        </Modal>
    )
}

function CheckDuplicate({
    data, 
    setData, 
    url, 
    itemTitle, 
    itemKey, 
    itemValue, 
    hashKey, 
    hashKeyName, 
    inputType, 
    history, 
    path1, 
}){
    const setShowLoader = useMyStore(state => state.setShowLoader);
    const [itemInvalid, setItemInvalid] = useState({[itemKey]: itemValue});
    return(
        <>
        <div className = "mb-2 d-flex align-items-center">
            <span className = "font-weight-bold">{itemTitle}:</span>
            <input 
                type = {inputType}
                className = "form-control flex-grow-1 ml-3"
                name = {itemKey}
                pattern = {
                    itemInvalid[hashKeyName]?
                    `^(?!${data[itemKey]}$).*`
                    :undefined
                }
                value = {data[itemKey] ?? ""}
                onChange = {e => setData({
                    ...data,
                    [itemKey]: e.currentTarget.value
                })}
                onBlur = {async e => {
                    const target = e.currentTarget.value;
                    if(!target){
                        setItemInvalid({});
                        return;
                    }
                    if(target === itemValue){
                        setItemInvalid({[itemKey]: itemValue});
                        return;
                    }
                    const formData = new MyFormData();
                    formData.append(hashKeyName, hashKey || "");
                    formData.append(itemKey, target);
                    //------------------------------------------------------------
                    setShowLoader(true);
                    const res = await myAxios(url, formData);
                    setShowLoader(false);
                    if(!res) return;
                    //------------------------------------------------------------
                    if(res.data === ""){
                        setItemInvalid({});
                    }else{
                        setItemInvalid(res.data);
                    }
                }}
            />
        </div>
        {itemInvalid[hashKeyName]?
        <div className = "mb-2">
            <div className = "font-weight-bold text-danger">
                This email has already existed in database with&nbsp;
                <span className = "pointer text-danger" onClick = {() => {
                        history.push(`/${path1}/${itemInvalid[hashKeyName]}`);
                    }}>
                        {itemInvalid.firstName} {itemInvalid.lastName}
                </span>
            .</div>
        </div>
        :<></>}
        </>
    )
}